<template>
  <div v-show="slider_img.length >= 3" class="container recommend">
    <indexTitle english_title="Recommended Exhibition" chinese_title="推薦展覽"></indexTitle>
    <div class="swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in slider_img" :key="item.id">
            <!-- <a :href="htp.concat(item.exhibit_domain.domain)"  target="_blank" class="d-flex"> -->
            <a :href="item.url" target="_blank" class="d-flex">
              <div class="slide_img col-5">
                <img :src='item.image_url'>
              </div>

              <div class="slideinfo d-flex col-7">
                <div class="recommend_name" :title='item.name'>{{ item.title }}</div>
                <div class="recommend_icon">
                  <div><i class="fa fa-calendar"></i>{{ item.exhibit.start_date }}~{{ item.exhibit.end_date.slice(5, 10) }}
                  </div>
                  <div><i class="fa fa-map-marker "></i>{{ item.address.name }}</div>
                </div>
                <div class="recommend_ticket">
                  <a :href="item.url" target="_blank">
                    <p>{{ item.url_display }} ⇀</p>
                  </a>
                </div>
              </div>

            </a>
          </div>
          <div v-show="slider_img.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
            <img src="../../assets/loading.gif">
          </div>
        </div>
        <!-- <div class="swiper-pagination"></div> -->


      </div>
      <!-- <div class="swiper-pagination"></div> -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>


    </div>
  </div>
</template>

<script>
import IndexTitle from '@/components/index/IndexTitle'
// import MoreButton from '@/components/index/MoreButton'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
  name: 'recommend',
  props: {},
  components: {
    'indexTitle': IndexTitle,
    // 'moreButton':MoreButton
  },

  data() {
    return {
      htp: 'https://',
      slidesPerView: 3,
      slider_img: []
    }
  },
  computed: {
  },
  mounted() {
    var vm = this
    var slider_api = process.env.VUE_APP_API + 'tlweb/recommend'
    vm.axios.get(slider_api)
      .then(function (response) {
        vm.slider_img = response.data.data.data.filter(function (item) {
          return item.address != null && item.exhibit_domain != null && item.exhibit != false;
        });
        setTimeout(() => {
          vm.swiper()
        }, 100)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    swiper() {
      new Swiper('.recommend .swiper-container', {
        slidesPerView: this.slidesPerView,
        spaceBetween: 30,
        pagination: {
          clickable: true,
        },
        breakpoints: {
          1000: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
      });
    }
  }
}
</script>

<style lang="sass">
  .recommend
    max-width: 1110px
    background: #eeeeee
    padding: 10px 0
  .swiper
    position: relative
  .recommend
    .swiper-container
      width: 90%
      height: 95%
      margin: 20px auto
    a
      text-decoration: none
      color: black
      .slide_img
        width: 162px
        padding: 0
        img
          width: 100%
          height: 100%
          max-width: 132px
          max-height: 185px
      .slideinfo
        box-sizing: border-box
        width: 198px
        background: white
        padding: 10px
        font-weight: 700
        justify-content: space-between
        flex-direction: column
    .recommend_name
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-box-orient: vertical
      -webkit-line-clamp: 2
    .recommend_icon
      font-size: 13px
      i
        width: 15px
        height: 15px
        text-align: center
        margin: 5px 5px 0 0
    .recommend_ticket
      a
        color: #00a0e9
        p
          margin: 0
          text-overflow: ellipsis
          overflow: hidden
          white-space: nowrap
      transition: all .2s
      &:hover
        transform: scale(1.05, 1.05)
    .swiper-pagination
      left: 50%
      margin-top: -15px
      transform: translate(-50%)
      .swiper-pagination-bullet
        margin: 0 3px
    .title_border
      display: none
  @media (max-width: 768px)
    .recommend
      a .slideinfo
        width: 100%
      .swiper-container
        width: 85%
        height: 100%
  @media (max-width: 500px)
    .swiper-button-next, .swiper-button-prev
      transform: scale(1.3)
      width: 12px
      background-size: 12px 44px
</style>
